module.exports = __webpack_public_path__ + "static/img/warning_1.2b6adc6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/warning_1.png
// module id = WRfO
// module chunks = 1